module.exports = "<p>\n  smtp works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/System settings/smtp/smtp.component.html
// module id = ./src/app/Dashboard/DashboardPages/System settings/smtp/smtp.component.html
// module chunks = main